import type { Finding, OverviewItem } from '../api-types';

export interface FindingRow {
  readonly item: OverviewItem;
  readonly finding: Finding;
}

/** Every finding of the items at this level, with the item it belongs to. */
export function rowsOf(items: readonly OverviewItem[]): FindingRow[] {
  return items.flatMap((item) => item.findings.map((finding) => ({ item, finding })));
}

/** The search matches the name and the message, in any case; the kind is exact. */
export function narrow(rows: readonly FindingRow[], q: string, kind: string | null): FindingRow[] {
  const needle = q.trim().toLowerCase();
  return rows.filter(
    ({ item, finding }) =>
      (kind === null || kind === '' || finding.kind === kind) &&
      (needle === '' ||
        item.name.toLowerCase().includes(needle) ||
        finding.message.toLowerCase().includes(needle)),
  );
}

/** One page of rows; `page` is 1-based and clamped to what exists. */
export function pageOf<T>(rows: readonly T[], page: number, size: number) {
  const pages = Math.max(1, Math.ceil(rows.length / size));
  const current = Math.min(Math.max(1, page), pages);
  return { rows: rows.slice((current - 1) * size, current * size), page: current, pages };
}

/** Folders at this level, and the totals the «Da sistemare» tile shows. */
export function totalsOf(items: readonly OverviewItem[]) {
  let total = 0;
  let inLine = 0;
  let findings = 0;
  for (const item of items) {
    total += item.progress?.total ?? 0;
    inLine += item.progress?.inLine ?? 0;
    findings += item.findings.length;
  }
  return { total, inLine, toFix: total - inLine, findings };
}
